<template>
  <div class="faq-container">
    <h2 class="faq-title">Q&A</h2>
    <ul class="faq-list">
      <li v-for="(item, index) in faqItems" :key="index" class="faq-item">
        <button class="question-button" @click="toggleAnswer(index)" :class="{ 'active': isOpen(index) }">
          <span class="toggle-icon">{{ isOpen(index) ? '✕' : '+' }}</span>
          {{ item.question }}
        </button>
        <div v-show="isOpen(index)" class="answer">
          <p v-html="item.answer"></p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { makeAffiliateUrl2 } from '@/utils/aff.js';

const affiliateLink = makeAffiliateUrl2();

const faqItems = ref([
  {
    question: 'とにかく急ぎで交換したい。最短いつ来てもらえますか？',
    answer: `依頼した時間やエリアにもよりますが、当サイトで紹介している <a href="${affiliateLink}" target="_blank" rel="nofollow noopener">お湯が出ない.com</a> であれば、最短即日の対応が可能です。<br><br>無料相談も実施しているため、まずは最短でいつ対応可能かを公式サイトから問い合わせてみましょう。`
  },
  {
    question: '給湯器の見積もりは無料ですか？',
    answer: '当サイトで紹介している専門業者は、現地調査や見積もりは無料で対応しています。契約前に料金が発生することはありませんので、まずは気軽に問い合わせてみると安心です。'
  },
  {
    question: '補助金や助成金は利用できますか？',
    answer: `一定の性能を満たす高効率給湯器（エコキュート・エネファーム・ハイブリッド給湯器）に交換する場合、国から補助金を受けることができます。ただし地域や機種によって金額が異なります。<br>当サイトで紹介している <a href="${affiliateLink}" target="_blank">お湯が出ない.com</a> は補助金申請に対応しているため、まずは無料相談してみましょう。`
  },
  {
    question: '給湯器を交換する場合の相場はいくらですか？',
    answer: '専門業者であれば、本体と工事費を含めておおよそ15万円〜30万円前後が目安です。メーカーや号数、設置条件によって費用は変わるため、複数社の見積もりを比較すると安心です。'
  },
  {
    question: 'ガス会社より安く交換できますか？',
    answer: `はい、多くの場合ガス会社よりも安く交換可能です。<br><br>ガス会社は本体価格や工事費に中間マージンが加算されるため、<strong>総額が高くなるケースが一般的</strong>です。<br><br>一方、給湯器専門業者はメーカーから直接仕入れを行っているため、<strong>最大90％以上割引</strong>で提供でき、工事費込みでもガス会社より数万円以上お得になることが多いです。<br><br>まずは<strong>無料見積もり</strong>で比較してみると安心です。<br><a href="${affiliateLink}" target="_blank">無料見積もりを依頼する▶︎</a>`
  }
]);

const activeIndex = ref(null);

const toggleAnswer = (index) => {
  activeIndex.value = activeIndex.value === index ? null : index;
};

const isOpen = (index) => {
  return activeIndex.value === index;
};
</script>

<style scoped>
/* 既存スタイルそのまま（変更なし） */
.faq-container {
  padding: 1.25rem;
  max-width: 700px;
  margin: 0 auto;
  background: #f9f9f9;
}

.faq-title {
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 2rem;
  text-align: center;
  position: relative;
}

.faq-title::after {
  content: '';
  display: block;
  margin: 0.5rem auto 0;
  width: 6rem;
  height: 0.3rem;
  background-color: #3f51b5;
}

.faq-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.faq-item {
  margin-bottom: 1rem;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 0.3rem;
  overflow: hidden;
}

.question-button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  transition: background-color 0.3s;
}

.question-button:hover {
  background-color: #f0f0f0;
}

.toggle-icon {
  font-size: 1.25rem;
  color: #555;
  margin-right: 0.5rem;
  width: 1.25rem;
  text-align: center;
  transition: transform 0.3s;
}

.question-button.active .toggle-icon {
  transform: rotate(45deg);
}

.answer {
  padding: 1rem;
  font-size: 0.9rem;
  line-height: 1.6;
  background-color: #fff;
  border-top: 1px solid #ddd;
  text-align: left;
}

.answer a {
  color: #3f51b5;
  font-weight: bold;
  text-decoration: underline;
}

/* === スマホ調整 === */
@media (max-width: 600px) {
  .faq-title {
    font-size: 2rem;
    margin-top: 10px;
  }

  .question-button {
    font-size: 1rem;
    padding: 0.9rem;
  }

  .toggle-icon {
    font-size: 1.5rem;
  }

  .answer {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .faq-title {
    font-size: 1.6rem;
    margin-top: 10px;
  }

  .question-button {
    font-size: 1rem;
    padding: 0.5rem;
  }

  .toggle-icon {
    font-size: 1.5rem;
  }

  .answer {
    font-size: 0.9rem;
  }
}
</style>
